import { isEmpty } from 'lodash'
import { success } from '@/utils/alert'
import { mapActions } from 'vuex'

export default {
  ...mapActions(['loadProfessional']),
  prepareSave (graduation) {
    if (isEmpty(graduation.attachment.content)) {
      delete graduation.attachment
    }
    return graduation
  },
  afterCreated () {
    success('Graduação incluida com sucesso.')
  },
  afterUpdated () {
    success('Graduação alterada com sucesso.')
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/curriculum/graduations/form/resources/methods.js